let fontSize = "8vw";
const mediaQuery = window.matchMedia("(max-width: 1200px)");
function funColumn() {
  var begin = Date.now();
  let football = document.getElementById("grid_football");
  let footballVideo = document.querySelector("#football_video");

  let gridGirl = document.getElementById("grid_girl");
  let gridVideo = document.querySelector("#girl_video");

  let gridBoy = document.getElementById("grid_boy");
  let boyVideo = document.querySelector("#boy_video");

  let gridBone = document.getElementById("grid_bone");
  let boneVideo = document.querySelector("#bone_video");
  function footBallAnimaEnter() {
    football.style.zIndex = 1;
    gsap.to("#football_img", {
      opacity: 0,
      scrub: 1,
    });
    gsap.to("#football_video", {
      opacity: 1,
      scrub: 1,
    });
    if (mediaQuery.matches) {
      gsap.to(".afterPath", {
        opacity: 0,
        duration: 0.3,
        scrub: 1,
      });
      gsap.to(".beforePath", {
        opacity: 1,
        duration: 0.3,
        scrub: 1,
      });
      gsap.to("#grid_football", {
        width: "100%",
        height: "215%",
        scrub: 1,
      });
      gsap.to("#fun_bone", {
        opacity: 0,
        scrub: 1,
      });
      football.removeEventListener("click", footBallAnimaEnter);
      football.addEventListener("click", footBallAnimaLeave);
    } else {
      gsap.to("#grid_football", {
        width: "162%",
        height: "166%",
        scrub: 1,
      });
    }
    footballVideo.play();
  }
  function footBallAnimaLeave() {
    gsap.to("#grid_football", {
      width: "100%",
      height: "100%",
      scrub: 1,
    });
    gsap.to("#football_img", {
      opacity: 1,
      scrub: 1,
    });
    gsap.to("#football_video", {
      opacity: 0,
      scrub: 1,
      onComplete: () => {
        football.style.zIndex = 0;
        footballVideo.currentTime = 0;
        footballVideo.pause();
      },
    });
    if (mediaQuery.matches) {
      gsap.to(".afterPath", {
        opacity: 1,
        duration: 0.3,
        scrub: 1,
      });
      gsap.to(".beforePath", {
        opacity: 0,
        duration: 0.3,
        scrub: 1,
      });
      gsap.to("#fun_bone", {
        opacity: 1,
        scrub: 1,
      });
      football.removeEventListener("click", footBallAnimaLeave);
      football.addEventListener("click", footBallAnimaEnter);
    }
  }
  function gridGirlEnter() {
    gridGirl.style.zIndex = 1;
    gridGirl.style.position = "absolute";
    gridGirl.style.bottom = 0;
    gridGirl.style.left = 0;
    gsap.to("#fun_girl", {
      opacity: 0,
    });
    gsap.to("#girl_video", {
      opacity: 1,
      scrub: 1,
    });
    gsap.to("#football_img", {
      opacity: 0,
      scrub: 1,
    });
    if (mediaQuery.matches) {
      gsap.to(".afterPath", {
        opacity: 0,
        duration: 0.3,
        scrub: 1,
      });
      gsap.to(".beforePath", {
        opacity: 1,
        duration: 0.3,
        scrub: 1,
      });
      gsap.to("#fun_bone", {
        opacity: 0,
        scrub: 1,
      });
      gsap.to("#grid_girl", {
        width: "210%",
        height: "200%",
        scrub: 1,
      });
      gridGirl.removeEventListener("click", gridGirlEnter);
      gridGirl.addEventListener("click", gridGirlLeave);
    } else {
      gsap.to("#grid_girl", {
        width: "162%",
        height: "271%",
        scrub: 1,
      });
    }
    gridVideo.play();
  }
  function gridGirlLeave() {
    gsap.to("#grid_girl", {
      width: "100%",
      height: "100%",
      scrub: 1,
    });
    gsap.to("#fun_girl", {
      opacity: 1,
    });
    gsap.to("#girl_video", {
      opacity: 0,
      scrub: 1,
    });
    gsap.to("#football_img", {
      opacity: 1,
      scrub: 1,
      onComplete: () => {
        gridVideo.currentTime = 0;
        gridVideo.pause();
        gridGirl.style.zIndex = 0;
      },
    });
    if (mediaQuery.matches) {
      gsap.to(".afterPath", {
        opacity: 1,
        duration: 0.3,
        scrub: 1,
      });
      gsap.to(".beforePath", {
        opacity: 0,
        duration: 0.3,
        scrub: 1,
      });
      gsap.to("#fun_bone", {
        opacity: 1,
        scrub: 1,
      });
      gridGirl.removeEventListener("click", gridGirlLeave);
      gridGirl.addEventListener("click", gridGirlEnter);
    }
  }
  function gridBoyEnter() {
    gridBoy.style.zIndex = 1;
    gridBoy.style.position = "absolute";
    gridBoy.style.top = 0;
    gridBoy.style.right = 0;
    gsap.to("#fun_boy", {
      opacity: 0,
    });
    gsap.to("#boy_video", {
      opacity: 1,
      scrub: 1,
    });
    gsap.to("#football_img", {
      opacity: 0,
      scrub: 1,
    });
    if (mediaQuery.matches) {
      gsap.to(".afterPath", {
        opacity: 0,
        duration: 0.3,
        scrub: 1,
      });
      gsap.to(".beforePath", {
        opacity: 1,
        duration: 0.3,
        scrub: 1,
      });
      gsap.to("#fun_bone", {
        opacity: 0,
        scrub: 1,
      });
      gsap.to("#grid_boy", {
        width: "213%",
        height: "424%",
        top: "-212%",
        scrub: 1,
      });
      gridBoy.removeEventListener("click", gridBoyEnter);
      gridBoy.addEventListener("click", gridBoyLeave);
    } else {
      gsap.to("#grid_boy", {
        width: "275%",
        height: "205%",
        scrub: 1,
      });
    }
    boyVideo.play();
  }
  function gridBoyLeave() {
    gsap.to("#fun_boy", {
      opacity: 1,
    });
    gsap.to("#boy_video", {
      opacity: 0,
      scrub: 1,
    });
    gsap.to("#football_img", {
      opacity: 1,
      scrub: 1,
      onComplete: () => {
        boyVideo.currentTime = 0;
        boyVideo.pause();
        gridBoy.style.zIndex = 0;
      },
    });
    gsap.to("#grid_boy", {
      top: "0%",
      width: "100%",
      height: "100%",
      scrub: 1,
    });
    if (mediaQuery.matches) {
      gsap.to(".afterPath", {
        opacity: 1,
        duration: 0.3,
        scrub: 1,
      });
      gsap.to(".beforePath", {
        opacity: 0,
        duration: 0.3,
        scrub: 1,
      });
      gsap.to("#fun_bone", {
        opacity: 1,
        scrub: 1,
      });
      gridBoy.removeEventListener("click", gridBoyLeave);
      gridBoy.addEventListener("click", gridBoyEnter);
    }
  }
  function gridBoneEnter() {
    gridBone.style.zIndex = 1;
    gridBone.style.position = "absolute";
    gridBone.style.bottom = 0;
    gridBone.style.right = 0;
    gsap.to("#fun_bone", {
      opacity: 0,
    });
    gsap.to("#bone_video", {
      opacity: 1,
      scrub: 1,
    });
    gsap.to("#football_img", {
      opacity: 0,
      scrub: 1,
    });
    if (mediaQuery.matches) {
      gsap.to(".afterPath", {
        opacity: 0,
        duration: 0.3,
        scrub: 1,
      });
      gsap.to(".beforePath", {
        opacity: 1,
        duration: 0.3,
        scrub: 1,
      });
      gsap.to("#fun_bone", {
        opacity: 0,
        scrub: 1,
      });
      gsap.to("#grid_bone", {
        width: "210%",
        height: "423%",
        scrub: 1,
      });
      gridBone.removeEventListener("click", gridBoneEnter);
      gridBone.addEventListener("click", gridBoneLeave);
    } else {
      gsap.to("#grid_bone", {
        width: "275%",
        height: "206%",
        scrub: 1,
      });
    }
    boneVideo.play();
  }
  function gridBoneLeave() {
    gsap.to("#grid_bone", {
      width: "100%",
      height: "100%",
      scrub: 1,
    });
    gsap.to("#fun_bone", {
      opacity: 1,
    });
    gsap.to("#bone_video", {
      opacity: 0,
      scrub: 1,
    });
    gsap.to("#football_img", {
      opacity: 1,
      scrub: 1,
      onComplete: () => {
        boneVideo.currentTime = 0;
        boneVideo.pause();
        gridBone.style.zIndex = 0;
      },
    });
    if (mediaQuery.matches) {
      gsap.to(".afterPath", {
        opacity: 1,
        duration: 0.3,
        scrub: 1,
      });
      gsap.to(".beforePath", {
        opacity: 0,
        duration: 0.3,
        scrub: 1,
      });
      gsap.to("#fun_bone", {
        opacity: 1,
        scrub: 1,
      });
      gsap.to("#grid_bone", {
        width: "100%",
        height: "100%",
        scrub: 1,
      });
      gridBone.removeEventListener("click", gridBoneLeave);
      gridBone.addEventListener("click", gridBoneEnter);
    }
  }
  if (mediaQuery.matches) {
    football.addEventListener("click", footBallAnimaEnter);
    footballVideo.firstChild.src =
      "https://cdn.shopify.com/videos/c/o/v/2809f2d48a0c462d89030df45888982c.mp4";
    footballVideo.load();

    gridGirl.addEventListener("click", gridGirlEnter);
    gridVideo.firstChild.src =
      "https://cdn.shopify.com/videos/c/o/v/4662d29b893e4d85b984c243856f6f83.mp4";
    gridVideo.load();

    gridBoy.addEventListener("click", gridBoyEnter);
    boyVideo.firstChild.src =
      "https://cdn.shopify.com/videos/c/o/v/c08f30ae2bf0418e8d67623f7036a6fe.mp4";
    boyVideo.load();

    gridBone.addEventListener("click", gridBoneEnter);
    boneVideo.firstChild.src =
      "https://cdn.shopify.com/videos/c/o/v/2b9e3943b3d04c80af7222be9ed0cf9b.mp4";
    boneVideo.load();
  } else {
    football.addEventListener("mouseover", footBallAnimaEnter);
    football.addEventListener("mouseleave", footBallAnimaLeave);

    gridGirl.addEventListener("mouseover", gridGirlEnter);
    gridGirl.addEventListener("mouseleave", gridGirlLeave);

    gridBoy.addEventListener("mouseover", gridBoyEnter);
    gridBoy.addEventListener("mouseleave", gridBoyLeave);

    gridBone.addEventListener("mouseover", gridBoneEnter);
    gridBone.addEventListener("mouseleave", gridBoneLeave);
  }
}
function dynamics() {
  var begin = Date.now();
  const mediaQuery = window.matchMedia("(max-width: 1200px)");
  let video = document.querySelector("#dynamics_video");
  let videoSource = document.querySelector("#dynamics_video source");
  if (mediaQuery.matches) {
    videoSource.src =
      "https://cdn.shopify.com/videos/c/o/v/e73eb7cadcb34e38a85c6238db9bdd91.mp4";
    video.load();
    video.play();
  } else {
    videoSource.src =
      "https://cdn.shopify.com/videos/c/o/v/57f326fa18474b7c97868cef3b424ff5.mp4";
    video.load();
    video.play();
  }
}
document.addEventListener("DOMContentLoaded", (event) => {
  dynamics();
  funColumn();
  gsap.registerPlugin(ScrollTrigger);
});
document.addEventListener("scroll", (event) => {
  let element = document.getElementById("dynamics_video");
  let rect = element.getBoundingClientRect();
  let windowHeight =
    window.innerHeight || document.documentElement.clientHeight;
  let windowWidth = window.innerWidth || document.documentElement.clientWidth;

  if (rect.bottom < 0 || rect.top > windowHeight) {
    if (element.currentTime == 0) {
      return;
    } else {
      element.currentTime = 0;
      element.pause();
    }
  } else {
    element.play();
  }
});
